export default __webpack_public_path__ + "static/media/60.b5e025db.jpeg";